import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { whitepapers } from "./whitepaperData";
import WhitepaperModal from "./whitepaperpopup/WhitepaperModal";
import { motion } from "motion/react";
import { ArrowRight } from "lucide-react";

const Whitepapers = () => {
  const [selectedWhitepaper, setSelectedWhitepaper] = useState(null);

  return (
    <>
      <style>{`
        .whitepapers-page {
          font-family: 'Outfit', sans-serif;
          background-color: #f8fafc;
        }
        .whitepaper-hero {
          padding: 100px 0 100px;
          background: #e2f1fe;
          color: #fff;
          text-align: center;
          position: relative;
          overflow: hidden;
        }

        .hero-title-container {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          text-align: left;
          max-width: 600px;
        }

        .whitepaper-hero h1 {
          font-weight: 800;
          margin-bottom: 10px;
          font-size: 42px;
          text-align: left;
          color: #0f172a;
          letter-spacing: -.5px;
        }

        .whitepaper-hero p {
          font-size: 16px;
          color: #475569;
          text-align: left;
          max-width: 900px;
          margin-bottom: 0px;
        }

        .hero-icon {
          position: absolute;
          top: 50%;
          right: 10%;
          transform: translateY(-50%);
          opacity: 0.2;
          pointer-events: none;
        }

        .whitepaper-listing {
          padding: 80px 0;
        }
        .whitepaper-card {
          height: 100%;
          display: flex;
          flex-direction: column;
          transition: all 0.4s ease;
          background: #fff;
          border-radius: 0;
          border: none;
          overflow: hidden;
          transition: all 0.4s ease;
          width: 100%;
         
        }
        .whitepaper-card:hover {
          transform: translateY(-6px);
          border-color: #e00;
        }
        .whitepaper-card img {
          width: 100%;
          height: auto;
          display: block;
        }
        .whitepaper-card-body {
          padding: 10px;
          flex-grow: 1;
          display: flex;
          flex-direction: column;
          
        }
        .whitepaper-title {
          font-size: 18px;
          font-weight: 700;
          color: #0f172a;
          margin-bottom: 15px;
          line-height: 1.4;
        }
        .whitepaper-actions {
          margin-top: auto;
          padding-top: 15px;
          margin-left: 0px;
        }
        .whitepaper-excerpt {
          color: #d1d5db;
          margin-bottom: 14px;
        }
        .whitepaper-actions a{
          margin-right: 8px;
          margin-bottom: 6px;
          text-decoration: none;
          color: #fff;
          background: #ee0000;
          border: 0;
          border-radius: 8px;
          padding: 8px 14px;
          font-weight: 600;
          font-size: 14px;
          cursor: pointer;
            margin-top: auto;
        }

          
        // .whitepaper-actions button {
        //   margin-right: 8px;
        //   margin-bottom: 6px;
        //   text-decoration: none;
        //   color: #fff;
        //   background: #ee0000;
        //   border: 0;
        //   border-radius: 8px;
        //   padding: 8px 14px;
        //   font-weight: 600;
        //   font-size: 14px;
        //   cursor: pointer;
        //     margin-top: auto;
        // }


          .whitepaper-actions button {
          margin-right: 8px;
          text-decoration: none;
          color: #ee0000;
          background: transparent;
          border: 0;
          border-radius: 8px;
          padding:0px;
          font-weight: 600;
          font-size: 14px;
          cursor: pointer;
            margin-top: auto;
            display: flex;
  align-items: center;   
        }


        .whitepaper-actions a.details {
          color: #e00;
          background: #fff;
          border: 1px solid #e00;
        }

        .hero-monitor-icon {
  position: absolute;
  top: 50%;
  right: 10%;
  transform: translateY(-50%);
  opacity: 0.2;
  pointer-events: none;
}

        @media (max-width: 768px) {
          .whitepaper-hero h1 {
            font-size: 32px;
          }
          .whitepaper-hero p {
            font-size: 14px;
          }
        }
      `}</style>

      <div className="whitepapers-page">
        <section className="whitepaper-hero">
          <Container>
            <div className="hero-title-container">
              <motion.div
                className="hero-title-container"
                initial={{ opacity: 0, x: -30 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
              >
                <h1>White Papers</h1>
                <p>Documenting Technical Expertise & Domain Know-how</p>
              </motion.div>
              <div className="hero-monitor-icon">
                <svg
                  width="200"
                  height="200"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="0.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
                  <line x1="8" y1="21" x2="16" y2="21"></line>
                  <line x1="12" y1="17" x2="12" y2="21"></line>
                </svg>
              </div>
            </div>
          </Container>
        </section>

        <section className="whitepaper-listing">
          <Container>
            <Row className="g-4">
              {whitepapers.map((whitepaper, idx) => (
                <Col
                  key={whitepaper.id}
                  lg={4}
                  md={6}
                  sm={12}
                  className="d-flex"
                >
                  <motion.div
                    className="w-100 d-flex"
                    style={{ width: "100%" }}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4, delay: idx * 0.1 }}
                  >
                    <div className="whitepaper-card">
                      <img
                        src={whitepaper.image}
                        alt={whitepaper.title}
                        className="whitepaper-card-img-top"
                      />
                      <div className="whitepaper-card-body">
                        <h5 className="whitepaper-title">{whitepaper.title}</h5>
                        <p className="whitepaper-excerpt">
                          {whitepaper.excerpt}
                        </p>

                        <div className="whitepaper-actions">
                          {/* <Link
                            to={`/white-paper/${whitepaper.slug}`}
                            className="details"
                          >
                            View Details
                          </Link> */}
                          <button
                            className="download-btn"
                            onClick={() => setSelectedWhitepaper(whitepaper)}
                          >
                            Download pdf
                            <ArrowRight className="ms-2" size={14} />
                          </button>
                        </div>
                      </div>
                    </div>
                  </motion.div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        {selectedWhitepaper && (
          <WhitepaperModal
            show={!!selectedWhitepaper}
            onHide={() => setSelectedWhitepaper(null)}
            whitepaperTitle={selectedWhitepaper.title}
            whitepaperPdfFile={selectedWhitepaper.pdfFile}
          />
        )}
      </div>
    </>
  );
};

export default Whitepapers;
